/* 

A = P((1 + (r/n))nt)

where

P = principal
r = rate expressed as a decimal
n = number of times interest is compounded in a year.
t = number of years 

Interest Rate on your account is 4.2656% with an Annual Percentage Yield of 4.35%.
*/

const MONTHS = 12;
const DEFAULT_START_BALANCE = 10000;
const DEFAULT_RATE = 5;
const DEFAULT_YEARS = 1;

export const GRAPH_COLOR = 'hsl(185, 82%, 22%)';

export const compounded = (principal, rateAsDecimal, compoundingFreq, numYears) => {
  const periods = compoundingFreq * numYears;
  const amount = principal * Math.pow((1 + (rateAsDecimal / compoundingFreq)), periods);
  return amount;
}


// Breaks an array into chunks of the indicated size. For our purposes: size = 12.
const chunk = (array, size=1) => {
  let list = array;
  return [...Array(Math.ceil(list.length / size))].map(() => list.splice(0, size));
}

// Get the last element in each year chunk.
const each_year = (chunks) => {
  return chunks.flatMap((c) => c.slice(c.length - 1))
}


export const compounded_by_period = (principal, rateAsDecimal, compoundingFreq, numYears) => {
  let periods = (compoundingFreq * numYears);
  let i = 0;

  let perPeriod = [];

  while(i <= periods) {
    perPeriod[i] = principal * Math.pow((1 + (rateAsDecimal / compoundingFreq)), i);
    i++;
  }

  if(compoundingFreq === MONTHS) {
    perPeriod = each_year(chunk(perPeriod, MONTHS));
  }

  return perPeriod;
}

export const prep_number = (number) => {
  return number.toString().replace(/[,$]/g, '');
}

export const formatted_number = (number) => {
  const num = prep_number(number)
  return new Intl.NumberFormat('en-US').format( parseFloat(num) );
}

export const formatted_currency = (number) => {
  const num = prep_number(number)
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format( parseFloat(num) );
}

export const numeric_to_number = (numeric_string) => {
  return parseFloat(prep_number( numeric_string ));
}

export const to_float = (percent) => {
  return percent / 100;
}

export const to_percentage = (percent) => {
  return percent * 100;
}

export const pluralize = (input) => {
  const plu = new Intl.PluralRules("en-US");

  const suffixes = new Map([
    ["one", ""],
    ["two", "s"],
    ["few", "s"],
    ["other", "s"],
  ]);

  const rule = plu.select(+input);
  return `year${suffixes.get(rule)}`;
}

export const make_chart_data = (years, raw_data = []) => {

  let c_data = [];

  for(var i = 0; i <= years; i++) {
    c_data.push({
      name: (i == 0) ? 'Start' : `Year ${i}`,
      amount: raw_data[i],
    });
  }

  return c_data;
}

export const reducer = (state, action) => {
  let value;
  let compound_monthly = state.monthly ? 12 : 1;

  switch(action.type) {
    case 'principal':
      value = { [action.type]: formatted_number(action.value) };
      break;
    case 'rate':
      value = { [action.type]: parseFloat(action.value) };
      break;
    case 'years':
      value = { [action.type]: parseFloat(action.value) };
      break;    
    case 'monthly':
      value = { [action.type]: !state.monthly };
      break;
    case 'recalculate':
      value = {
        balance: formatted_currency(compounded(
          numeric_to_number(state.principal),
          to_float(state.rate),
          compound_monthly,
          state.years
        ))
      };
      break;
    default:
      value = action.value;
  }

  /* Generates an array of numbers with the ending balance by period */
  const by_period = compounded_by_period(
    numeric_to_number(state.principal),
    to_float(state.rate),
    compound_monthly,
    state.years
  );

  const ch = make_chart_data(
    state.years,
    by_period
  );

  const chartd = {chart: ch}

  return {
    ...state,
    ...value,
    ...chartd
  };
}

const startint = DEFAULT_START_BALANCE * to_float(DEFAULT_RATE);

export const initial_state = {
  principal: formatted_number(DEFAULT_START_BALANCE),
  rate: DEFAULT_RATE,
  years: DEFAULT_YEARS,
  balance: formatted_currency( DEFAULT_START_BALANCE + startint),
  monthly: false,
  chart: [
    {
      name: 'Start',
      amount: DEFAULT_START_BALANCE,
    },
    {
      name: 'Year 1',
      amount: (DEFAULT_START_BALANCE + startint),
    },
  ]
};

